import '@app/libs/polyfill';

import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import authService from '@app/libs/auth/authService';
import { activateDatadog } from '@app/libs/datadog';
import embeddedService from '@app/libs/embedded/embeddedService';

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * redux store 초기화보다 먼저 활성화돼야 합니다.
 */
activateDatadog();

/**
 * redux store 초기화보다 먼저 설정되어야 합니다.
 */
authService.setStorage(embeddedService.isEmbedded ? sessionStorage : localStorage);
